import $ from "jquery";

class FiltersService {
   hoverButton(id, imageHover) {
      $(id).attr("src", imageHover);
      $(id).parent().addClass(["card-form-process-button-hover"]);
      $(id).parent().removeClass(["card-form-process-button", "card-form-process-button-active"]);
   }

   unHoverButton(id, imageUnhover) {
      $(id).attr("src", imageUnhover);
      $(id).parent().addClass(["card-form-process-button"]);
      $(id).parent().removeClass(["card-form-process-button-active", "card-form-process-button-hover"]);
   }

   activeButton(id, imageActive) {
      $(id).attr("src", imageActive);
      $(id).parent().addClass(["card-form-process-button-active"]);
      $(id).parent().removeClass(["card-form-process-button", "card-form-process-button-hover"]);
   }

   findProcesoElectoral(list, itemId) {
      return list.find((list) => list.ID_PROCESO_GENERAL === itemId);
   }

   disableProcesoExt(list) {
      return list.find((list) => list.ID_PROCESO_ELECTORAL == 2) ? false : true;
   }

   findAmbito(list, itemId) {
      return list.find((list) => list.ID_AMBITO === itemId);
   }

   findEntidad(list, itemId) {
      return list.find((list) => list.ID_ESTADO === itemId);
   }

   findMunicipio(list, itemId) {
      return list.find((list) => list.ID_MUNICIPIO === itemId);
   }

   findDistrito(list, itemId) {
      return list.find((list) => list.ID_DISTRITO === itemId);
   }

   findActorPolitico(list, itemId) {
      return list.find((list) => list.ID_SUJETO_OBLIGADO === itemId);
   }

   findCargo(list, itemId) {
      return list.find((list) => list.ID_TIPO_CANDIDATURA === itemId);
   }

   hideById(id) {
      $(id).hide();
   }

   showById(id) {
      $(id).show();
   }

   scrollToId(id) {
      $("body").scrollTo(id);
   }

   disableSearchButton() {
      $("#searchButton").prop("disabled", false);
   }
}

export default new FiltersService();
